<template>
<div>
  <v-container fluid grid-list-md>
  <v-progress-circular
      v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>
  <v-row>
  <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6" class="pr-1">
  <v-data-table
    dense
    :headers="headers"
    :items="mbtypes"
    sort-by="id"
    class="elevation-1"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50]
    }"
    :items-per-page="50"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{lang.MainLedgerProjectTypes}}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">

          <template v-slot:activator="{ on }">
            <v-btn fab dark class="indigo" v-on="on">
               <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>


          <v-card>
            <v-card-title>
              <span class="headline">{{ lang.MainLedgerProjectType }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >

                  <v-row>
                    <v-col cols="12" sm="12" md="6" xs="6" lg="6" xl="6" class="pr-1">
                     <v-text-field
                        dense
                        :label="lang.MainLedgerProjectTypeName"
                        v-model="editedItem.TypeName"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xs="6" lg="6" xl="6" class="pr-1">
                       <v-checkbox
                        v-model="editedItem.FreeB1"
                        :label="langC.Disabled"
                       ></v-checkbox>
                    </v-col>

                  </v-row>

                  <v-row v-if="errorMatch">                    
                      <div class="red" v-html="errorMatch" />
                  </v-row>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{langC.Cancel}}</v-btn>
                    <v-btn color="success" text @click="save">{{langC.Save}}</v-btn>  
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
 
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:[`item.FreeB1`]="{ item }">
      <span v-if="item.FreeB1"><v-icon>mdi-check</v-icon></span>
    </template>

    <template v-slot:[`item.action`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-trash-can
      </v-icon>
    </template>
    <template v-slot:no-data>
      {{ lang.MainLedgerProjectTypeEmpty }}
    </template>
  </v-data-table>
  </v-col>
  </v-row>
  </v-container>
  </div>
</template>

<script>
import MainLedgerProjectTypeService from '@/services/MainLedgerProjectTypeService'
import { defMainLedgerProjectType, defNewMainLedgerProjectType } from '../MainLedger/mainledgerHelper'
import langEn from './MainLedgerDescEN'
import langHr from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'

  export default {
    name: 'mainledgerprojecttype',
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal2: false,
      menu2: false,
      modal1: false,
      dialog1: false,
      lang: {},
      langC: {},
      saving: false,
      error: null,
      errorMatch: null,
      modal: false,
      show1: false,
      show2: false,
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: "",
        databaseDocID: 0
      },
      dialog: false,
      headers: [],
      mbtypes: [],
      editedIndex: -1,
      editedItem: { },
      defaultItem: {

      },
      privitems: [],
      valid: true,
      RecTrue: true,
      ExpTrue: false
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? this.lang.NewMainBookType: this.lang.EditMainBookType
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    components: {

    },

    mounted() {
      if (this.$store.state.language === "EN") {
        this.lang = langEn
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = langHr
        this.langC = commHr;
      }
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.mainQuery.businessYear = this.$store.state.businessYear
      }

      this.headers.push(
        {text: this.lang.MainLedgerProjectTypeName, value: 'TypeName', width: '400px'},
        {text: this.langC.Disabled, value: 'FreeB1', width: '50px'},
        {text: 'DbId', value: 'id', type: 'number', width: '50px'},
        {text: this.lang.Actions, value: 'action', sortable: false },
      ) 
      this.defaultItem = {...defMainLedgerProjectType(), ...defNewMainLedgerProjectType()}
      this.initialize()
    },

    created () {
      
    },

    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      async initialize () {
        try {
          this.saving = true
          this.mbtypes = (await MainLedgerProjectTypeService.index(this.mainQuery)).data.mainledgerprojecttype
          this.saving = false
          this.errorMatch = false
          this.editedItem ={...this.defaultItem}
        } catch (err) {
          this.error = err
        }
      },
      editItem (item) {
        this.errorMatch = false
        this.editedIndex = this.mbtypes.indexOf(item)
        this.editedItem = {...item}
        this.dialog = true
        this.confpassword = ''
      },

      async deleteItem (item) {
        try {
          const index = this.mbtypes.indexOf(item)
          const warningMessage = item.TypeName
          if (confirm(this.langC.AreYouShureToDelete + ' ' + warningMessage + '!') && this.mbtypes.splice(index, 1)) {
            await MainLedgerProjectTypeService.delete(item.id)
            this.initialize()
          }
        } catch(err) {
          this.error = err
          
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = {...this.defaultItem}
          this.editedIndex = -1
        }, 300)
      },

      checkMatch () {
        if (this.editedItem.password && this.confpassword &&  this.confpassword === this.editedItem.password) {
          this.errorMatch = null
          this.save()
        } else {
          this.errorMatch = 'Error. Passoword and Confirmation Password are NOT equal!'
          this.valid = false        
        }
      },

      async save () {
        try {
           let doneOK = false
           if (this.editedIndex > -1) {
              await MainLedgerProjectTypeService.put(this.editedItem)
              doneOK = true
            } else {
              await MainLedgerProjectTypeService.post(this.editedItem)
              doneOK = true
            }
            await MainLedgerProjectTypeService.index2(this.mainQuery).then(res => {
            if (res.data.mainledgerprojecttype) {
                this.$store.dispatch('setProjectTypes', res.data.mainledgerprojecttype)
              }
            })
            .catch(err => {
              console.log('Error init MainLedgerProjectTypes ', err)
            })
            if (doneOK) {
              this.initialize()
              this.close()
            }
        } catch(err) {
          this.error = err
        }
       
      },
      localDate(dateToFormat) {
       return dateFormat(dateToFormat)
      }
    },
  }
</script>